module.exports = __webpack_public_path__ + "static/media/image1.b7f4d7fb.png";